import React from "react";
import { User, GraduationCap, Bot } from "lucide-react";
import Message from "types/Message";

interface MessageAvatarProps {
  messageType: Message["type"];
  size?: "sm" | "md" | "lg";
}

export function MessageAvatar({
  messageType,
  size = "md",
}: MessageAvatarProps) {
  const sizes = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-10 h-10",
  };

  const iconSizes = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5",
  };

  const getAvatarContent = () => {
    switch (messageType) {
      case "user":
      case "question":
      case "alert":
      case "info":
        return (
          <div
            className={`bg-green-100 rounded-full flex items-center justify-center ${sizes[size]}`}
          >
            <User className={`text-green-600 ${iconSizes[size]}`} />
          </div>
        );
      case "assistant":
        return (
          <div
            className={`bg-green-100 rounded-full flex items-center justify-center ${sizes[size]}`}
          >
            <Bot className={`text-green-600 ${iconSizes[size]}`} />
          </div>
        );
      case "teacher":
        return (
          <div
            className={`bg-gray-100 rounded-full flex items-center justify-center ${sizes[size]}`}
          >
            <GraduationCap className={`text-gray-600 ${iconSizes[size]}`} />
          </div>
        );
      case "teacher-response":
        return (
          <div
            className={`bg-gray-100 rounded-full flex items-center justify-center ${sizes[size]}`}
          >
            <Bot className={`text-gray-600 ${iconSizes[size]}`} />
          </div>
        );
      default:
        return (
          <div
            className={`bg-gray-200 rounded-full flex items-center justify-center ${sizes[size]}`}
          >
            <User className={`text-gray-500 ${iconSizes[size]}`} />
          </div>
        );
    }
  };

  return getAvatarContent();
}
